"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Tiktok24InvertedSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 19, height: 22, viewBox: "0 0 19 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0002 0C14.3632 3.1219 15.9707 4.98316 19.0002 5.18117V8.69248C17.2445 8.86409 15.7888 8.28987 14.0002 7.20743V13.7746C14.0002 22.1173 4.68903 24.7244 1.03251 18.7446C-1.31717 14.8967 0.462735 8.14466 8.00018 7.87406V11.5768C7.42596 11.6692 6.47109 11.8144 5.91007 12.0058C4.23361 12.5734 3.28318 13.636 3.54719 15.5105C3.71893 18.7446 10.548 20.1637 10.0002 13.1476V0.00660021H14.0002V0Z", fill: "#B2B5BD" }));
}
function Tiktok24Inverted(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Tiktok24InvertedSvg, Object.assign({}, svgProps)));
}
exports.default = Tiktok24Inverted;
//# sourceMappingURL=Tiktok24Inverted.js.map